/**
 * Groups the staff lines and the tree-guarantee seal on a `WorkshopList`
 * card — the seal sits at the end of the same row as the staff names, pushed
 * right, matching the design.
 */
import { WorkshopListSeal } from './WorkshopListSeal';
import type { WorkshopListSize } from './workshopListSizes';
import { WorkshopListStaff } from './WorkshopListStaff';

export interface WorkshopListStaffSealRowProps {
  teacher?: string | null;
  assistant?: string | null;
  showTeacher: boolean;
  showAssistant: boolean;
  replacements?: number;
  showSeal: boolean;
  size?: WorkshopListSize;
}

export function WorkshopListStaffSealRow({
  teacher,
  assistant,
  showTeacher,
  showAssistant,
  replacements,
  showSeal,
  size = 'md',
}: WorkshopListStaffSealRowProps) {
  if (!showTeacher && !showAssistant && !showSeal) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, marginTop: 7 }}>
      <WorkshopListStaff
        teacher={teacher}
        assistant={assistant}
        showTeacher={showTeacher}
        showAssistant={showAssistant}
        size={size}
      />
      <WorkshopListSeal show={showSeal} count={replacements} size={size} />
    </div>
  );
}
